<SettingsLayout page='settings/wellness' label="Wellness">
  <h1>Wellness settings</h1>

  <p>
    Wellness settings are designed to reduce the addictive or anxiety-inducing aspects of social media. Choose any options that work well for you.
  </p>

  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-check-all"
             on:change="onCheckAllChange(event)">
      Enable all
    </label>
  </form>

  <h2>Metrics</h2>

  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-follower-counts"
             bind:checked="$disableFollowerCounts" on:change="onChange(event)">
      Hide follower counts (capped at 10)
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-reblog-counts"
             bind:checked="$disableReblogCounts" on:change="onChange(event)">
      Hide boost counts
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-fav-counts"
             bind:checked="$disableFavCounts" on:change="onChange(event)">
      Hide favorite counts
    </label>
  </form>

  <h2>Immediacy</h2>

  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-unread-notification-counts"
             bind:checked="$disableNotificationBadge" on:change="onChange(event)">
      Hide unread notifications count (i.e. the red dot)
    </label>
    <label class="settings-group">
      <input type="checkbox" id="choice-disable-relative-timestamps"
             bind:checked="$disableRelativeTimestamps" on:change="onChange(event)">
      Show absolute timestamps (e.g. "March 3rd") instead of relative timestamps (e.g. "5 minutes ago")
    </label>
  </form>

  <InfoAside className="wellness-aside">
    You can filter or disable notifications in the
    <a rel="prefetch" href="/settings/instances{$currentInstance ? '/' + $currentInstance : ''}">instance settings</a>.
    
  </InfoAside>

  <h2>UI</h2>

  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-grayscale"
             bind:checked="$enableGrayscale" on:change="onChange(event)">
      Grayscale mode
    </label>
  </form>
  <p>
    These settings are partly based on guidelines from the <a rel="noopener" target="_blank" href="https://humanetech.com">Center for Humane Technology</a>.
  </p>
</SettingsLayout>
<UISettingsStyles />
<style>
  :global(.wellness-aside) {
    margin: 20px 10px 0px 10px;
  }
</style>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import { store } from '../../_store/store.js'
  import InfoAside from '../../_components/InfoAside.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'

  export default {
    oncreate () {
      this.flushChangesToCheckAll()
    },
    components: {
      SettingsLayout,
      InfoAside,
      UISettingsStyles
    },
    methods: {
      flushChangesToCheckAll () {
        const {
          disableFollowerCounts,
          disableReblogCounts,
          disableFavCounts,
          disableNotificationBadge,
          disableRelativeTimestamps,
          enableGrayscale
        } = this.store.get()
        document.querySelector('#choice-check-all').checked = disableFollowerCounts &&
          disableReblogCounts &&
          disableFavCounts &&
          disableNotificationBadge &&
          disableRelativeTimestamps &&
          enableGrayscale
      },
      onCheckAllChange (e) {
        const { checked } = e.target
        this.store.set({
          disableFollowerCounts: checked,
          disableReblogCounts: checked,
          disableFavCounts: checked,
          disableNotificationBadge: checked,
          disableRelativeTimestamps: checked,
          enableGrayscale: checked
        })
        this.store.save()
      },
      onChange () {
        this.flushChangesToCheckAll()
        this.store.save()
      }
    },
    store: () => store
  }
</script>
